<p *ngFor="let alert of Alerts">
    <ngb-alert [type]="alert.Type" (closed)="close($any($event))"><span [innerHTML]="alert.Message"></span></ngb-alert>
</p>